import {
  Container,
  Stack,
  Flex,
  Box,
  Heading,
  Text,
  Button,
  Image,
  IconButton,
  createIcon,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const CallToActionWithVideo = () => {
  const navigate = useNavigate();

  const handleCreateCampaign = () => {
    navigate('/signup');
  };

  return (
    <Container maxW={'100%'} height={'575px'} px={{ base: 4, md: 6 }} py={{ base: 16, md: 20 }}>
      <Stack
        align={'center'}
        spacing={{ base: 8, md: 10 }}
        direction={{ base: 'column', lg: 'row' }}>
        <Stack flex={1} spacing={{ base: 5, md: 7 }}>
          <Heading
            lineHeight={1.2}
            fontWeight={700}
            fontSize={{ base: '4xl', sm: '3xl', lg: '4xl' }}>
            <Text
              as={'span'}
              position={'relative'}
              _after={{
                content: "''",
                width: 'full',
                height: '2%',
                position: 'absolute',
                bottom: -1,
                left: 0,
                bg: 'red.500',
                zIndex: 1,
              }}>
              Empower Your Business,
            </Text>
            <br />
            <Text as={'span'} color={'red.500'}>
              Connect with Customers!
            </Text>
          </Heading>
          <Text color={'gray.500'} fontSize={{ base: 'md', sm: 'lg', lg: 'xl' }}>
            Our CRM platform helps you streamline your marketing efforts,
            engage with your audience, and drive growth. 
            Manage campaigns, track customer interactions, and
            optimize your business strategies all in one place.
          </Text>
          <Stack spacing={{ base: 4, sm: 6 }} direction={{ base: 'column', sm: 'row' }}>
            <Button
              rounded={'full'}
              size={'lg'}
              fontWeight={'bold'}
              px={8}
              colorScheme={'red'}
              bg={'red.500'}
              _hover={{ bg: 'red.600' }}
              onClick={handleCreateCampaign}>
              Get Started Now
            </Button>
            <Button
              rounded={'full'}
              size={'lg'}
              fontWeight={'bold'}
              px={8}
              leftIcon={<PlayIcon h={5} w={5} color={'gray.300'} />}>
              See It In Action
            </Button>
          </Stack>
        </Stack>
        <Flex
          flex={1}
          justify={'center'}
          align={'center'}
          position={'relative'}
          w={'full'}
          mt={{ base: 10, lg: 0 }}>
          <Box
            position={'relative'}
            height={{ base: '250px', sm: '300px', md: '350px' }}
            rounded={'1xl'}
            boxShadow={'dark-lg'}
            width={'100%'}
            overflow={'hidden'}>
            <IconButton
              aria-label={'Play Button'}
              variant={'ghost'}
              _hover={{ bg: 'transparent' }}
              icon={<PlayIcon w={12} h={12} />}
              size={'lg'}
              color={'white'}
              position={'absolute'}
              left={'50%'}
              top={'50%'}
              transform={'translateX(-50%) translateY(-50%)'}
            />
            <Image
              alt={'Marketing Video'}
              fit={'cover'}
              align={'center'}
              w={'150%'}
              h={'100%'}
              src={
                'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
              }
            />
          </Box>
        </Flex>
      </Stack>
    </Container>
  );
};

const PlayIcon = createIcon({
  displayName: 'PlayIcon',
  viewBox: '0 0 58 58',
  d: 'M28.9999 0.562988C13.3196 0.562988 0.562378 13.3202 0.562378 29.0005C0.562378 44.6808 13.3196 57.438 28.9999 57.438C44.6801 57.438 57.4374 44.6808 57.4374 29.0005C57.4374 13.3202 44.6801 0.562988 28.9999 0.562988ZM39.2223 30.272L23.5749 39.7247C23.3506 39.8591 23.0946 39.9314 22.8332 39.9342C22.5717 39.9369 22.3142 39.8701 22.0871 39.7406C21.86 39.611 21.6715 39.4234 21.5408 39.1969C21.4102 38.9705 21.3421 38.7133 21.3436 38.4519V19.5491C21.3421 19.2877 21.4102 19.0305 21.5408 18.8041C21.6715 18.5776 21.86 18.3899 22.0871 18.2604C22.3142 18.1308 22.5717 18.064 22.8332 18.0668C23.0946 18.0696 23.3506 18.1419 23.5749 18.2763L39.2223 27.729C39.4404 27.8619 39.6207 28.0486 39.7458 28.2713C39.8709 28.494 39.9366 28.7451 39.9366 29.0005C39.9366 29.2559 39.8709 29.507 39.7458 29.7297C39.6207 29.9523 39.4404 30.1391 39.2223 30.272Z',
});

export default CallToActionWithVideo;
